import { render, staticRenderFns } from "./ot-checkbox-group-set.vue?vue&type=template&id=0847f540&scoped=true&"
import script from "./ot-checkbox-group-set.vue?vue&type=script&lang=ts&"
export * from "./ot-checkbox-group-set.vue?vue&type=script&lang=ts&"
import style0 from "./ot-checkbox-group-set.vue?vue&type=style&index=0&id=0847f540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847f540",
  null
  
)

export default component.exports